<template>
  <div class="MyFollow">
    <div class="PageCommon">
      <div class="bscroll" ref="bscroll">
        <div class="bscroll-container">
          <h3 class="pageTitle" v-if="!mobileFlag">
            {{ $t("Menu_Followers_Invited") }}
            <div class="refreshListBtnDiv">
              <el-button class="confirmDialogBtn" @click="refreshList()">
                {{ $t("Common_Operation_Refresh") }}
                <i class="el-icon-refresh-right"></i>
              </el-button>
            </div>
          </h3>

          <div class="tableDiv" v-if="!mobileFlag">
            <el-table :data="tableData" style="width: 100%" ref="dataTable">
              <el-table-column prop="portfolioName" :label="$t('Common_TableTitle_SignalSource')">
              </el-table-column>
              <el-table-column prop="portfolioLoginId" width="120" :label="$t('Common_TableTitle_SignalSourceEmail')">
              </el-table-column>
              <el-table-column width="100" prop="shareProfitPercent" :label="$t('Common_TableTitle_PLSharingRatio')">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.shareProfitPercent
                        ? scope.row.shareProfitPercent + "%"
                        : 0 + " %"
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="100" prop="durationName" :label="$t('Common_TableTitle_SignalSettlementCycle')">
              </el-table-column>
              <el-table-column prop="percent" :label="$t('Common_TableTitle_CopyRatio')">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.percent ? scope.row.percent + "%" : 0 + " %"}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="maxVolume" :label="$t('Common_TableTitle_MaxLot')">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.maxVolume == 0
                        ? $t("Common_TR_VolumeNotLimit")
                        : scope.row.maxVolume
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="symbols" width="135" :label="$t('Common_TableTitle_Instruments')">
                <template slot-scope="scope">
                  <div>
                    <span class="symbolsSpan" v-if="scope.row.forexSelect">
                      {{ $t("Common_Fx") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.metalsSelect">
                      {{ $t("Common_Metal") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.energySelect">
                      {{ $t("Common_Energy") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.indicesSelect">
                      {{ $t("Common_Indices") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.cryptoSelect">
                      {{ $t("Common_Crypto") }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="160" :label="$t('Common_TableTitle_AutoMatchOrder')">
                <template slot-scope="scope">
                  <div>
                    <el-result v-if="scope.row.autoRecon" icon="success"></el-result>
                    <el-result v-if="!scope.row.autoRecon" icon="error"></el-result>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :width="flexLabelWidth($t('Common_TableTitle_ActivationStatus'))
                " :label="$t('Common_TableTitle_ActivationStatus')">
                <template slot-scope="scope">
                  <div>
                    <el-result v-if="scope.row.activation" icon="success"></el-result>
                    <el-result v-if="!scope.row.activation" icon="error"></el-result>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="150" prop="createTime" :label="$t('Common_TableTitle_InviteTime')">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.createTime }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column :fixed="tableData.length !== 0 ? 'right' : false" v-if="!mobileFlag" width="180"
                :label="$t('Common_TableTitle_Operation')">
                <template slot-scope="scope">
                  <div class="operateBtns">
                    <el-button @click="checkFollow(scope.row)" type="text" size="small"
                      v-loading.fullscreen.lock="fullscreenLoading">
                      <svg-icon class="greenIcon" icon-class="CheckIcon"></svg-icon>
                      {{ $t("Common_Operation_ViewInvitation") }}
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :fixed="tableData.length !== 0 ? 'right' : false" v-if="mobileFlag" width="80"
                :label="$t('Common_TableTitle_Operation')">
                <template slot-scope="scope">
                  <div class="operateBtns">
                    <el-popover placement="bottom-end" trigger="click">
                      <el-button @click="checkFollow(scope.row)" type="text" size="small"
                        v-loading.fullscreen.lock="fullscreenLoading">
                        <svg-icon class="greenIcon" icon-class="CheckIcon"></svg-icon>
                        {{ $t("Common_Operation_ViewInvitation") }}
                      </el-button>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination class="tablePage" :prev-text="$t('Common_PreviousPage')" :next-text="$t('Common_NexPage')"
              @current-change="handleCurrentChange" :current-page="currentPage" @size-change="handleSizeChange"
              :page-sizes="[5, 10, 20, 50, 100]" :pager-count="5" :page-size="pageSize"
              layout="prev, pager, next, sizes" :total="total">
            </el-pagination>
          </div>

          <div class="mobileTableList" v-show="mobileFlag">
            <el-collapse accordion @change="collapseChange" v-model="activeCollapse">
              <el-collapse-item v-for="(item, index) in tableData" :key="index" :name="index">
                <template slot="title">
                  <div class="mobileTableCard" @click.stop="showCollapse()">
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_SignalSource") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.portfolioName }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_SignalSourceEmail") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.portfolioLoginId }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_PLSharingRatio") }}
                      </p>
                      <p class="mobileTableContent">
                        {{
                          item.shareProfitPercent
                            ? item.shareProfitPercent + "%"
                            : 0 + " %"
                        }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_SignalSettlementCycle") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.durationName }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_CopyRatio") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.percent ? item.percent + "%" : 0 + " %"}}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_MaxLot") }}
                      </p>
                      <p class="mobileTableContent">
                        {{
                          item.maxVolume == 0
                            ? $t("Common_TR_VolumeNotLimit")
                            : item.maxVolume
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="mobileTableBtns" @click.stop="showCollapse()">
                    <el-button class="mobileBlueBtn" v-if="item.status == 0" @click="checkFollow(item)" type="text"
                      size="small" v-loading.fullscreen.lock="fullscreenLoading">
                      <svg-icon class="greenIcon" icon-class="CheckIcon"></svg-icon>
                      {{ $t("Common_Operation_ViewInvitation") }}
                    </el-button>
                  </div>
                </template>
                <div class="mobileTableCard">
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_Instruments") }}
                    </p>
                    <p class="mobileTableContent">
                      <span class="symbolsSpan" v-if="item.forexSelect">
                        {{ $t("Common_Fx") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.metalsSelect">
                        {{ $t("Common_Metal") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.energySelect">
                        {{ $t("Common_Energy") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.indicesSelect">
                        {{ $t("Common_Indices") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.cryptoSelect">
                        {{ $t("Common_Crypto") }}
                      </span>
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_AutoMatchOrder") }}
                    </p>
                    <p class="mobileTableContent">
                      <el-result v-if="item.autoRecon" icon="success"></el-result>
                      <el-result v-if="!item.autoRecon" icon="error"></el-result>
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_ActivationStatus") }}
                    </p>
                    <p class="mobileTableContent">
                      <el-result v-if="item.activation" icon="success"></el-result>
                      <el-result v-if="!item.activation" icon="error"></el-result>
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_InviteTime") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.createTime }}
                    </p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="x" v-if="up && tableData.length < total">
              <i class="el-icon-loading"></i>
              {{ $t("Common_Loading") }}
            </div>
            <div class="x" v-if="!up && tableData.length >= total">
              {{ $t("Common_NoMoreData") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer :title="followDrawerTitle" class="drawerCommon checkInviteDrawer" :append-to-body="true"
      @close="closeDrawer()" :close-on-press-escape="false" :visible.sync="checkInviteDrawer" direction="rtl">
      <div class="drawerContent">
        <el-form :model="followForm" :rules="followRule" ref="followForm" label-width="150px"
          class="drawerForm" :label-position="mobileFlag ? 'top' : 'right'">
          <!-- 跟单参数设置 -->
          <div v-show="checkInviteParameter">
            <h3 class="checkInviteDrawerTitle">
              <i></i> {{ $t("ViewInvitation_ParameterSetting") }}
            </h3>
            <el-form-item :label="$t('Common_TableTitle_PLSharingRatio')">
              <el-input disabled v-model="followForm.shareProfitPercent"></el-input>
              <b class="formPercent">%</b>
            </el-form-item>
            <el-form-item :label="$t('Common_TableTitle_SignalSettlementCycle')">
              <el-input disabled v-model="followForm.settlementPeriodTypeTitle"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ViewInvitation_FirstSettlementTime')">
              <el-input disabled v-model="followForm.currentSettlementEndTime"></el-input>
            </el-form-item>
            <el-form-item prop="following">
              <span slot="label">
                <span class="label-box">
                  <span>{{ $t("Common_TableTitle_CopyRatio") }} </span>
                  <a href="javascript:;" @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_CopyRatio'),
                      $t('ViewInvitation_CopyPercentTxt'),
                      $t('ViewInvitation_CopyPercentTxt1')
                    )
                    ">
                    <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                  </a>

                  <div class="labelIconTxt">
                    <i class="el-icon-caret-top labelIconBack"></i>
                    <div>
                      <div>
                        {{ $t("ViewInvitation_CopyPercentTxt") }}
                      </div>
                      <br />
                      <div>
                        {{ $t("ViewInvitation_CopyPercentTxt1") }}
                      </div>
                    </div>
                  </div>
                </span>
              </span>
              <el-input disabled v-model.number="followForm.following" autocomplete="off"></el-input>
              <b class="formPercent">%</b>
            </el-form-item>
            <el-form-item prop="maxVolume">
              <span slot="label">
                <span class="label-box">
                  <span>{{ $t("Common_TableTitle_MaxLot") }} </span>
                  <a href="javascript:;" @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_MaxLot'),
                      $t('ViewInvitation_MaxVolumnTxt')
                    )
                    ">
                    <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                  </a>
                  <div class="labelIconTxt">
                    <i class="el-icon-caret-top labelIconBack"></i>
                    <div>
                      <div>
                        {{ $t("ViewInvitation_MaxVolumnTxt") }}
                      </div>
                      <br />
                      <div>
                        {{ $t("ViewInvitation_MaxVolumnTxt1") }}
                      </div>
                    </div>
                  </div>
                </span>
              </span>
              <el-input-number disabled class="creaseInput" controls-position="right"
                v-model.number="followForm.maxVolume" :placeholder="$t('Common_TR_VolumeNotLimit')"
                autocomplete="off"></el-input-number>
              <b class="formLots">lots</b>
            </el-form-item>
            <el-form-item :label="$t('Common_TableTitle_Instruments')">
              <el-input disabled v-model="followForm.symbols"></el-input>
            </el-form-item>
            <el-form-item prop="autoRecon">
              <span slot="label">
                <span class="label-box">
                  <span>{{ $t("Common_TableTitle_AutoMatchOrder") }} </span>
                  <a href="javascript:;" @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_AutoMatchOrder'),
                      $t('ViewInvitation_IsAutoTxt')
                    )
                    ">
                    <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                  </a>
                  <div class="labelIconTxt">
                    <i class="el-icon-caret-top labelIconBack"></i>{{ $t("ViewInvitation_IsAutoTxt") }}
                  </div>
                </span>
              </span>
              <el-radio-group v-model="followForm.autoRecon" disabled>
                <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
                <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="activation" :label="$t('Common_TableTitle_ActivationStatus')">
              <span slot="label">
                <span class="label-box">
                  <span>{{ $t("Common_TableTitle_ActivationStatus") }} </span>
                  <a href="javascript:;" @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_ActivationStatus'),
                      $t('ViewInvitation_MainActiveTxt')
                    )
                    ">
                    <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                  </a>
                  <div class="labelIconTxt">
                    <i class="el-icon-caret-top labelIconBack"></i>{{ $t("ViewInvitation_MainActiveTxt") }}
                  </div>
                </span>
              </span>
              <el-radio-group v-model="followForm.activation" disabled>
                <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
                <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- 同意邀请后展示账号设置 -->
          <div v-show="checkInviteDetailAccount">
            <h3 class="checkInviteDrawerTitle">
              <i></i>{{ $t("ViewInvitation_AcceptInvitation") }}
            </h3>
            <el-form-item :label="$t('Common_Mt4BrokerName')" prop="brokerName" class="toReg">
              <el-select :disabled="isFollowing" v-model="followForm.brokerName" @change="selectChange">
                <el-option v-for="item in brokerList" :key="item.id" :label="item.brokerName" :value="item.id">
                </el-option>
              </el-select>
              <p>
                <span @click="toReg()">{{
                  $t("ViewInvitation_NoAccountRegister")
                }}</span>
              </p>
            </el-form-item>
            <el-form-item :label="$t('Common_Mt4Server')" prop="serverId">
              <el-select v-model="followForm.serverId" class="allLengthInput" :disabled="isFollowing">
                <el-option v-for="item in serverList" :key="item.serverId" :label="item.serverName"
                  :value="item.serverId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Common_Mt4Account')" prop="account">
              <el-input :disabled="isFollowing" v-model="followForm.account" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item v-if="checkRow.status == 0" :label="$t('Common_Mt4AccountPassword')" prop="cwPassword">
              <el-input type="password" v-model="followForm.cwPassword" autocomplete="off" show-password></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="drawerBtns" v-if="checkInviteDetailAccount">
          <el-button class="confirmDialogBtn" v-loading.fullscreen.lock="fullscreenLoading" @click="followSubmit(1)">{{
            $t("Common_Confirm") }}</el-button>

          <el-button class="cancelDialogBtn" @click.stop="followNext(false)">{{
            $t("Common_Back")
          }}</el-button>
        </div>
        <div class="drawerBtns" v-if="checkRow.status == 0 && !checkInviteDetailAccount">
          <el-button class="confirmDialogBtn" v-loading.fullscreen.lock="fullscreenLoading" @click="followNext(true)">{{
            $t("ViewInvitation_AcceptInvitation") }}</el-button>

          <el-button class="cancelDialogBtn" @click.stop="isRefuse = true">{{
            $t("ViewInvitation_RejectInvitation")
          }}</el-button>
        </div>
        <div class="refuseCard" v-if="isRefuse" ref="refuseCard">
          <p v-if="mobileFlag">
            {{ $t("ViewInvitation_RejectInvitation") }}
          </p>
          <i v-show="mobileFlag" @click="isRefuse = false" class="el-icon-close refuseIcon"></i>
          <el-input type="textarea" :rows="6" :placeholder="$t('ViewInvitation_RejectInvitation_DEMO')"
            v-model="refuseReason">
          </el-input>
          <el-button class="confirmDialogBtn" @click="followSubmit(2)">{{
            $t("Common_Complete")
          }}</el-button>
        </div>
      </div>
    </el-drawer>
    <div class="mobileLabelTips" ref="mobileLabelTips" v-if="isLableTips">
      <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
      <p>
        {{ labelTitle }}
      </p>
      <div>
        <div>
          {{ labelTxt }}
        </div>
        <br />
        <div v-if="labelSubContent">
          {{ labelSubContent }}
        </div>
      </div>
    </div>
    <PopupTips :popupVisible="isPopupVisible" :icon="iconImg" :title="$t('Common_Prompt')"
      @confirmPopupTips="confirmPopup" @cancelPopupTips="cancelPopup" ref="popupTipsRef" :isShowClose="isShowClose"
      :confirmTxt="confirmTxt" :cancelTxt="cancelTxt" :subContent="$t(subContent)" :content="$t(popupContent)"
      :btnType="btnType" />
  </div>
</template>

<script>
import { concatParams, concatTableData } from "../../plugins/common.js";
import { mapState } from "vuex";
import PopupTips from "@/components/moudule/PopupTips.vue";
import load2 from "@/components/moudule/Loading.vue";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import Bus from "../../plugins/bus";
import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";

BScroll.use(Pullup);

export default {
  name: "MyFollow",
  components: {
    PopupTips,
    load2,
  },
  computed: {
    ...mapState(["checkPortfolio", "userInfo", "token", "mobileFlag", "lang"]),
  },
  data() {
    var checkMt4 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("Common_Valid_CheckMt4Account")));
      } else if (
        !Number.isInteger(Number(value)) ||
        value.length < 5 ||
        value.length > 10
      ) {
        callback(new Error(this.$t("Common_Valid_CheckMt4AccountNum")));
      } else {
        callback();
      }
    };
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 5,
      historyCurrentPage: 1,
      historyTotal: 0,
      historyPageSize: 5,
      checkInviteDrawer: false,
      fullscreenLoading: true,
      followForm: {
        account: "",
        following: 0,
        signalMaxDrawdown: 0,
        takeProfit: 0,
        maxDrawdown: 0,
        maxVolume: 0,
        symbols: "",
        autoRecon: true,
        activation: true,
        maxDrawdownStopFollow: false,
        takeProfitStopFollow: false,
        orderType: 0,
        profitType: 0,
        cwPassword: "",
        serverId: "",
        brokerName: 1,
        currentSettlementEndTime: "",
      },
      followRule: {
        account: [{ validator: checkMt4, trigger: "change" }],
        brokerName: [
          {
            required: true,
            message: this.$t("Common_Valid_BrokerNotNull"),
            trigger: "blur",
          },
        ],
        serverId: [
          {
            required: true,
            message: this.$t("Common_valid_ServerNotNull"),
            trigger: "blur",
          },
        ],
        cwPassword: [
          {
            required: true,
            message: this.$t("Common_Valid_Mt4PasswordNotNull"),
            trigger: "blur",
          },
        ],
      },
      checkRow: {},
      refuseReason: "",
      isRefuse: false,
      isFollowing: false,
      followDrawerTitle: "",
      activeName: "follow",
      historyTableData: [],
      labelTitle: "",
      labelTxt: "",
      isLableTips: false,
      accountList: [],
      isPopupVisible: false,
      iconImg: require("../../assets/images/NotifyWarning.svg"),
      isStopPopupVisible: false,
      isClosePopupVisible: false,
      btnType: 1,
      popupTitle: "",
      popupContent: "",
      clickType: "",
      cancelTxt: "",
      confirmTxt: "",
      isShowClose: false,
      totalProfit: 0,
      totalVolume: 0,
      brokerList: [],
      serverList: [],
      subContent: "",
      labelSubContent: "",
      up: false,
      firstOpen: false,
      activeCollapse: 0,
      goRegUrl: "",
      checkInviteParameter: true,
      checkInviteDetailAccount: true,
    };
  },
  watch: {},
  mounted() {
    this.$refs.popupTipsRef.rendered = true;
  },
  created() {
    this.getData();
    this.screenClick();
    this.getServeList();
  },
  methods: {
    formatNumberFractionDigits,
    refreshList() {
      this.getData();
    },
    collapseChange() {
      this.$nextTick(() => {
        if (!this.firstOpen) {
          this.scroll.maxScrollY = this.scroll.maxScrollY - 150;
          this.firstOpen = true;
        } else {
          this.scroll.maxScrollY = this.scroll.maxScrollY + 150;
          this.firstOpen = false;
        }
      });
    },
    scrollFn() {
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.bscroll, {
            click: true,
            scrollY: true,
            probeType: 3,
          });
        } else {
          this.scroll.refresh();
        }

        //touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
        this.scroll.on("touchEnd", (pos) => {
          //上拉加载 总高度>下拉的高度+10 触发加载更多
          if (this.scroll.maxScrollY > pos.y + 50) {
            this.up = true;
            setTimeout(() => {
              //使用refresh 方法 来更新scroll  解决无法滚动的问题
              if (this.tableData.length < this.total) {
                this.currentPage = this.currentPage + 1;
                this.getData("noRefresh");
                this.scroll.refresh();
                this.up = false;
              } else {
                this.up = false;
              }
            }, 1000);
          }
        });
      });
    },
    getServeList() {
      this.$axios.get("/Api/invite/BrokerList").then((res) => {
        let dt = res.data;
        if (dt.isSuccess) {
          this.brokerList = dt.result;
          this.goRegUrl = dt.result[0].registUrl;
          this.serverList = dt.result[0].serverList;
        }
      });
    },
    cancelPopup(val) {
      this.isPopupVisible = val;
      this.cancelTxt = "Common_Cancel";
      this.confirmTxt = "Common_Confirm";
      this.subContent = "";
      this.isShowClose = false;
      if (this.clickType == "stopCopy") {
        this.cancelStopPopup();
      }
    },
    confirmPopup(val) {
      this.isPopupVisible = val;
      this.cancelTxt = "Common_Cancel";
      this.confirmTxt = "Common_Confirm";
      this.subContent = "";
      this.isShowClose = false;
      if (this.clickType == "noChange") {
        this.allowSubmit();
      } else if (this.clickType == "stopCopy") {
        this.confirmStopPopup();
      } else if (this.clickType == "closeOrder") {
        this.confirmCloseOrder();
      }
    },

    getData(tag) {
      if (!this.mobileFlag || tag !== "noRefresh") {
        this.tableData = [];
      }
      var params = {
        status: 0,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$axios.get("/Api/Invite/List" + concatParams(params)).then((res) => {
        let dt = res.data;

        if (dt.isSuccess) {
          this.total = dt.result.total;
          this.totalProfit = dt.result.totalProfit;
          this.totalVolume = dt.result.totalVolume;
          if (this.mobileFlag && tag == "noRefresh") {
            dt.result.pageList.forEach((item) => {
              this.tableData.push(item);
            });
          } else {
            this.tableData = concatTableData(
              dt.result.pageList,
              dt.result.total,
              this.currentPage,
              this.pageSize
            );
          }

          this.fullscreenLoading = false;
          if (this.mobileFlag) {
            this.scrollFn();
          }

          console.log(this.tableData);
        }
      });
    },
    // 查看邀请
    checkFollow(row) {
      this.isFollowing = false;
      this.isRefuse = false;
      this.checkRow = row;
      this.checkInviteParameter = true;
      this.checkInviteDetailAccount = this.checkRow.status == 0 ? false : true;
      this.followDrawerTitle = this.$t("Common_Operation_ViewInvitation");
      var params = {
        id: row.id,
      };
      this.$axios
        .get("/Api/Invite/GetInvite" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.checkInviteDrawer = true;
            this.$nextTick(function () {
              this.followForm = Object.assign(this.followForm, dt.result);
              this.followForm.forexSelectLabel = this.followForm.forexSelect
                ? this.$t("Common_Fx")
                : "";
              this.followForm.energySelectLabel = this.followForm.energySelect
                ? this.$t("Common_Energy")
                : "";
              this.followForm.metalsSelectLabel = this.followForm.metalsSelect
                ? this.$t("Common_Metal")
                : "";
              this.followForm.indicesSelectLabel = this.followForm.indicesSelect
                ? this.$t("Common_Indices")
                : "";
              this.followForm.cryptoSelectLabel = this.followForm.cryptoSelect
                ? this.$t("Common_Crypto")
                : "";
              this.followForm.symbols =
                this.followForm.forexSelectLabel +
                " " +
                this.followForm.energySelectLabel +
                " " +
                this.followForm.metalsSelectLabel +
                " " +
                this.followForm.indicesSelectLabel +
                " " +
                this.followForm.cryptoSelectLabel;
              this.followForm.maxVolume =
                this.followForm.maxVolume == 0
                  ? undefined
                  : this.followForm.maxVolume;
            });
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    // 设置
    getSetting(row) {
      this.isFollowing = true;
      this.checkRow = row;
      this.isRefuse = false;
      this.followDrawerTitle = this.$t("Common_Setting");
      var params = {
        id: row.id,
      };
      this.$axios
        .get("/Api/Invite/GetSetting" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.checkInviteDrawer = true;
            this.$nextTick(function () {
              this.followForm = Object.assign(this.followForm, dt.result);
              this.followForm.forexSelectLabel = this.followForm.forexSelect
                ? this.$t("Common_Fx")
                : "";
              this.followForm.energySelectLabel = this.followForm.energySelect
                ? this.$t("Common_Energy")
                : "";
              this.followForm.metalsSelectLabel = this.followForm.metalsSelect
                ? this.$t("Common_Metal")
                : "";
              this.followForm.indicesSelectLabel = this.followForm.indicesSelect
                ? this.$t("Common_Indices")
                : "";
              this.followForm.cryptoSelectLabel = this.followForm.cryptoSelect
                ? this.$t("Common_Crypto")
                : "";
              this.followForm.symbols =
                this.followForm.forexSelectLabel +
                " " +
                this.followForm.energySelectLabel +
                " " +
                this.followForm.metalsSelectLabel +
                " " +
                this.followForm.indicesSelectLabel +
                " " +
                this.followForm.cryptoSelectLabel;
              this.followForm.maxVolume =
                this.followForm.maxVolume == 0
                  ? undefined
                  : this.followForm.maxVolume;
              this.followForm.orderType = 0;
              this.followForm.profitType = 0;
              this.brokerList.forEach((item) => {
                if (item.brokerName == dt.result.brokerName) {
                  this.followForm.brokerName = item.id;
                }
                item.serverList.forEach((subItem) => {
                  if (item.serverName == dt.result.serverName) {
                    this.followForm.serverId = subItem.id;
                  }
                });
              });
            });
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    closeDrawer() {
      this.$refs.followForm.resetFields();
      this.checkInviteDrawer = false;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage, this.pageSize);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage, this.pageSize);
    },
    followNext(status) {
      this.checkInviteParameter = status ? false : true;
      this.checkInviteDetailAccount = status ? true : false;
    },
    followSubmit(status) {
      this.$confirm(
        this.$t("ViewInvitation_NoChangePasswordContent"),
        this.$t("Common_Prompt"),
        {
          confirmButtonText: this.$t("Common_Confirm"),
          cancelButtonText: this.$t("Common_Cancel"),
          type: "warning",
        }
      ).then(() => {
        if (status == 1) {
          this.allowSubmit();
        } else {
          this.fullscreenLoading = true;
          var params = {
            id: this.checkRow.id,
            status: status,
            refuseReason: this.refuseReason,
          };
          this.$axios
            .post("/Api/Invite/PostInvite", params)
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.$notify.success({
                  title: this.$t("Common_Prompt"),
                  message: this.$t("Common_OperateSuccess"),
                });

                this.getData(this.currentPage, this.pageSize);
                this.$refs.followForm.resetFields();
                this.refuseReason = "";
                this.checkInviteDrawer = false;
                Bus.$emit("isInviteRefresh", true);
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result,
                });
              }
            })
            .finally(() => {
              this.fullscreenLoading = false;
            });
        }
      }).catch(error => { });
    },
    //同意邀请
    allowSubmit() {
      this.fullscreenLoading = true;
      var params = {
        id: this.checkRow.id,
        account: this.followForm.account,
        cwPassword: this.followForm.cwPassword,
        serverId: this.followForm.serverId,
        status: 1,
      };
      this.$axios
        .post("/Api/Invite/PostInvite", params)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.getData();
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
            this.$refs.followForm.resetFields();
            this.checkInviteDrawer = false;
            Bus.$emit("isInviteRefresh", true);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    // 设置保存  暂时取消
    followSettingSave(type) {
      this.fullscreenLoading = true;
      var setValue = 0;
      if (type == 1) {
        if (this.followForm.maxDrawdown) {
          setValue = this.followForm.maxDrawdown;
        } else {
          setValue = 0;
        }
      } else {
        if (this.followForm.takeProfit) {
          setValue = this.followForm.takeProfit;
        } else {
          setValue = 0;
        }
      }
      var params = {
        id: this.checkRow.id,
        setValue: setValue,
        type: type,
      };
      this.$axios
        .post("/Api/Invite/PostSetting", params)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });
            this.getData(this.currentPage, this.pageSize);
            this.checkInviteDrawer = false;
            this.$refs.followForm.resetFields();
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },

    // mt4选择
    selectChange(val) {
      this.brokerList.forEach((item, index) => {
        if (item.id == val) {
          this.serverList = item.serverList;
          this.goRegUrl = item.registUrl;
        }
      });
    },
    labelIconClick(title, content, subContent) {
      if (this.mobileFlag) {
        this.isLableTips = !this.isLableTips;
        this.labelTitle = title;
        this.labelTxt = content;
        this.labelSubContent = subContent;
      } else {
        this.isLableTips = false;
      }
    },
    screenClick() {
      // debugger
      document.addEventListener("click", (e) => {
        if (this.$refs.mobileLabelTips) {
          let self = this.$refs.mobileLabelTips.contains(e.target);
          if (!self) {
            this.isLableTips = false;
            this.labelSubContent = "";
          }
        }
        if (this.$refs.refuseCard) {
          let self = this.$refs.refuseCard.contains(e.target);
          if (!self) {
            this.isRefuse = false;
          }
        }
      });
    },
    toReg() {
      window.open(`https://crm.ecmarkets.co/${this.lang}/sign/register`);
    },
  },
};
</script>
<style lang="less" scoped>
.formLots {
  right: 12%;
}

.pageTitle {
  justify-content: flex-start;
  align-items: center;
}

.refreshListBtnDiv {
  margin-left: 10px;

  .confirmDialogBtn {
    color: #fff;
    text-align: center;
    font-family: "PingFangSC-Medium";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    padding: 8px 10px;
  }
}

@media screen and (max-width: 767px) {
  .tableDiv {
    padding-top: 40px !important;
  }
}
</style>
